module.exports = __webpack_public_path__ + "static/media/saunatimeFacebook-1200x630.a44cda4f.jpg";